import styled, { useTheme } from "styled-components";

import Icon from "../../../components/Icon/Icon";

const FieldButton = styled.button<{ $active: boolean }>`
  width: 100%;
  min-height: 50px;
  padding: 0 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  text-align: left;
  color: ${({ theme }) => theme.colorCopyDarkDark};
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colorActivation : theme.colorBorderLight};
  background: ${({ theme, $active }) =>
    $active ? theme.colorBackgroundLightLight : theme.colorBackgroundLight};
  box-shadow:
    0 0 0 ${({ $active }) => ($active ? "2px" : "1px")}
      ${({ theme, $active }) =>
        $active ? theme.colorActivation : theme.colorBorderLight} inset,
    0 2px 8px 0 ${({ theme }) => theme.colorBoxShadow};
  transition:
    background 160ms ease-in,
    border-color 160ms ease-in,
    box-shadow 160ms ease-in;

  &:hover {
    background: ${({ theme }) => theme.colorBackgroundLightLight};
    border-color: ${({ theme }) => theme.colorActivation};
  }

  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.colorActivation};
  }

  .copy {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.95rem;
    font-weight: ${({ $active }) => ($active ? 600 : 500)};
  }

  .placeholder {
    opacity: 0.55;
    font-weight: 400;
  }

  .icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 999px;
    background: ${({ theme, $active }) =>
      $active ? theme.colorActivation : theme.colorBackgroundLightLight};
  }
`;

type Props = {
  value?: string | null;
  placeholder?: string;
  active?: boolean;
  onClick(): void;
};

export default function ThemisFieldPickerButton({
  value,
  placeholder = "Select field",
  active = false,
  onClick,
}: Props) {
  const theme = useTheme();

  return (
    <FieldButton type="button" $active={active} onClick={onClick}>
      <span className="copy">
        <span className={`value${value ? "" : " placeholder"}`}>
          {value || placeholder}
        </span>
      </span>
      <span className="icon">
        <Icon
          icon="edit"
          color={active ? theme.colorBackgroundLightLight : theme.colorActivation}
          width="16px"
          height="16px"
        />
      </span>
    </FieldButton>
  );
}
